import React, { useState } from 'react';
import { performMigrations } from '../../../services/api';
import AdminLayout, { AdminBanner } from '../AdminLayout/AdminLayout';
import { useMessages } from '../../../i18n/I18n';
import './Migrations.css';

const Migrations: React.FC = () => {
  const t = useMessages('admin');
  const [masterKey, setMasterKey] = useState('');
  const [status, setStatus] = useState<{ type: 'success' | 'error', message: string } | null>(null);
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsLoading(true);
    setStatus(null);

    try {
      await performMigrations(masterKey);
      setStatus({ type: 'success', message: t.migrationsDone });
    } catch (err) {
      setStatus({ 
        type: 'error', 
        message: err instanceof Error ? err.message : t.migrationsFailed 
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <AdminLayout
      className="migrations-page"
      title={t.tools.migrations.title}
      description={t.migrationsDescription}
      hasBackLink
    >
      <section className="admin-card">
        {status && (
          <AdminBanner tone={status.type === 'success' ? 'success' : 'danger'}>{status.message}</AdminBanner>
        )}
        <form onSubmit={handleSubmit}>
          <div className="admin-field">
            <label htmlFor="masterKey">{t.masterKey}</label>
            <input
              type="password"
              id="masterKey"
              value={masterKey}
              onChange={(e) => setMasterKey(e.target.value)}
              required
            />
          </div>
          <div className="admin-actions">
            <button type="submit" className="btn btn-primary" disabled={isLoading}>
              {isLoading ? t.migrating : t.migrate}
            </button>
          </div>
        </form>
      </section>
    </AdminLayout>
  );
};

export default Migrations;
